// extracted by mini-css-extract-plugin
module.exports = {"Item":"reviews_Item__TfIyZ","Frame":"reviews_Frame__cPJ6t","Baltex":"reviews_Baltex__VbZnP","Button":"reviews_Button__xuSYC","Qnt":"reviews_Qnt___2odV"};